import { createContext, useContext } from "react";
import { RestHeaderMng, useRest } from "../common/rest";
import { ULoading } from "../common/ui.page";
import { CMainLoading } from "./cr.ui.slide";
import { useAccessToken } from "./access.token";

export function UserSession(props) {
    const { token, ...rest } = props;
    const accessToken = useAccessToken();

    return <RestHeaderMng headers={{ "access-token": accessToken.value }}>
        {props.children}
    </RestHeaderMng>
}

const UserContext = createContext()
export function UserManaged(props) {
    const { alt, ...rest } = props;
    const [user, reload] = useRest('user/info')

    return <UserContext.Provider value={{
        user,
        reload,
    }} {...rest} />
}


export function useUser() {
    const { user, reload } = useContext(UserContext)

    return {
        ...user,
        admin: user && user.roles.includes('admin'),

        reload,
    }
}